const exposed = {};
if (location.search && !/font/.test(location.search)) {
  // Special case for /perfect-ish-font-fallback/
  var a = document.createElement("a");
  a.href = location.href;
  a.search = "";
  history.replaceState(null, null, a.href);
}

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.add("eager");
  });
});

function tweet_(url) {
  open(
    "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url),
    "_blank"
  );
}
function tweet(anchor) {
  tweet_(anchor.getAttribute("href"));
}
expose("tweet", tweet);

function share(anchor) {
  var url = anchor.getAttribute("href");
  event.preventDefault();
  if (navigator.share) {
    navigator.share({
      url: url,
    });
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url);
    message("Article URL copied to clipboard.");
  } else {
    tweet_(url);
  }
}
expose("share", share);

function clap(button) {
  button.querySelector("b").textContent =
    parseInt(button.querySelector("b").textContent, 10) + 1;
  share(button);
}
expose("clap", clap);

expose("loadTweetImage", function (element) {
  if (element.nextElementSibling) {
    return true;
  }
  const src = element.getAttribute("data-src");
  const img = new Image();
  img.src = src;
  img.width = element.getAttribute("data-width");
  img.height = element.getAttribute("data-height");
  element.parentElement.appendChild(img);
  return true; // Allow default action
});

function message(msg) {
  var dialog = document.getElementById("message");
  dialog.textContent = msg;
  dialog.setAttribute("open", "");
  setTimeout(function () {
    dialog.removeAttribute("open");
  }, 3000);
}

function prefetch(e) {
  if (e.target.tagName != "A") {
    return;
  }
  if (e.target.origin != location.origin) {
    return;
  }
  var l = document.createElement("link");
  l.rel = "prefetch prerender";
  l.href = e.target.href;
  l.as = "document";
  document.head.appendChild(l);
}
document.documentElement.addEventListener("mouseover", prefetch, {
  capture: true,
  passive: true,
});
document.documentElement.addEventListener("touchstart", prefetch, {
  capture: true,
  passive: true,
});

var timeout = setTimeout(
  (onload = function () {
    clearTimeout(timeout);
    gaPageview();
  }),
  1000
);

var ref = +new Date();
function ping(event) {
  var now = +new Date();
  if (now - ref < 1000) {
    return;
  }
  gaEvent("page", event.type, Math.round((now - ref) / 1000));
  ref = now;
}
addEventListener("pagehide", ping);
addEventListener("visibilitychange", ping);
addEventListener(
  "click",
  function (e) {
    var button = e.target.closest("button");
    if (!button) {
      return;
    }
    gaEvent(
      "engagement",
      "button",
      button.getAttribute("aria-label") || button.textContent
    );
  },
  true
);
var selectionTimeout;
addEventListener(
  "selectionchange",
  function () {
    clearTimeout(selectionTimeout);
    var text = String(document.getSelection()).trim();
    if (text.split(/[\s\n\r]+/).length < 3) {
      return;
    }
    selectionTimeout = setTimeout(function () {
      gaEvent("engagement", "selection", text);
    }, 2000);
  },
  true
);

if (window.ResizeObserver && document.querySelector("header nav #nav")) {
  var progress = document.getElementById("reading-progress");

  var timeOfLastScroll = 0;
  var requestedAniFrame = false;
  function scroll() {
    if (!requestedAniFrame) {
      requestAnimationFrame(updateProgress);
      requestedAniFrame = true;
    }
    timeOfLastScroll = Date.now();
  }
  addEventListener("scroll", scroll);

  var winHeight = 1000;
  var bottom = 10000;
  function updateProgress() {
    requestedAniFrame = false;
    var percent = Math.min(
      (document.scrollingElement.scrollTop / (bottom - winHeight)) * 100,
      100
    );
    progress.style.transform = `translate(-${100 - percent}vw, 0)`;
    if (Date.now() - timeOfLastScroll < 3000) {
      requestAnimationFrame(updateProgress);
      requestedAniFrame = true;
    }
  }

  const observe = () => {
    new ResizeObserver(() => {
      const bottomOfMainContent = document.querySelector("#comments,footer");
      bottom =
        document.scrollingElement.scrollTop +
        bottomOfMainContent.getBoundingClientRect().top;
      winHeight = window.innerHeight;
      scroll();
    }).observe(document.body);
  };
  if (document.readyState != "loading") {
    observe();
  } else {
    document.addEventListener("DOMContentLoaded", observe);
  }
}

function expose(name, fn) {
  exposed[name] = fn;
}

addEventListener("click", (e) => {
  const handler = e.target.closest("[on-click]");
  if (!handler) {
    return;
  }
  const name = handler.getAttribute("on-click");
  const fn = exposed[name];
  if (!fn) {
    throw new Error("Unknown handler: " + name);
  }
  const doNotPrevent = fn(handler);
  if (!doNotPrevent) {
    e.preventDefault();
  }
});

// There is a race condition here if an image loads faster than this JS file. But
// - that is unlikely
// - it only means potentially more costly layouts for that image.
// - And so it isn't worth the querySelectorAll it would cost to synchronously check
//   load state.
document.body.addEventListener(
  "load",
  (e) => {
    if (e.target.tagName != "IMG") {
      return;
    }
    // Ensure the browser doesn't try to draw the placeholder when the real image is present.
    e.target.style.backgroundImage = "none";
  },
  /* capture */ "true"
);

window.addEventListener("message", (e) => {
  if (e.origin != "https://avif-webp-quality-setting.industrialempathy.com") {
    return;
  }
  if (e.data.height) {
    document.getElementById("tool").style.height = `${e.data.height + 60}px`;
  }
});

function gaEvent(category, action, value) {
  const body = `t=event&el=${encodeURIComponent(
    value
  )}&ec=${category}&ea=${encodeURIComponent(action)}&dp=${encodeURIComponent(
    location.href
  )}`;

  gaBeacon(body);
}

function gaPageview() {
  const body = `t=pageview`;

  gaBeacon(body);
}

let cid;
async function getCid() {
  if (cid) {
    return cid;
  }
  cid =
    ((await getCookie("_ga")) || "").replace(/^GA\d+\.\d+\./, "") ||
    Math.random() * 1000000;
  setCookie("_ga", `GA1.2.${cid}`, 365);
  return cid;
}

async function gaBeacon(body) {
  const cid = await getCid();
  body = `${body}&v=1&_v=j83&_s=1&dp=${encodeURIComponent(
    location.href
  )}&dt=${encodeURIComponent(
    document.title
  )}&dh=www.industrialempathy.com&dr=${encodeURIComponent(
    document.referrer
  )}&ul=${navigator.language.toLowerCase()}&de=UTF-8&tid=UA-141920860-1&cid=${cid}`;
  navigator.sendBeacon(
    document.documentElement.hasAttribute("v")
      ? "/api/report"
      : "https://www.industrialempathy.com/api/report",
    body
  );
}

async function setCookie(name, value, days) {
  const r = await fetch("/api/zwieback", {
    method: "POST",
    body: JSON.stringify({
      name,
      value,
      days,
    }),
    headers: {
      "x-vercel-debug-proxy-timing": "1",
    },
  });
  if (!r.ok) {
    throw new Error("Failed to make zwieback " + r.status);
  }
}

async function getCookie(name) {
  const r = await fetch("/api/zwieback", {
    headers: {
      "x-vercel-debug-proxy-timing": "1",
    },
  });
  if (!r.ok) {
    throw new Error("Out of zwieback " + r.status);
  }
  return (await r.json())[name];
}
